import { Component, ViewChild } from '@angular/core';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonService } from '../../../Model/Common/common.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { ComboService } from '../../../Model/Combo/combo.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { IDCardFrontBackService } from '../../../Model/ReportMaster/idcard-front-back.service';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { UtilityService } from '../../../Model/utility/utility.service';

@Component({
  selector: 'app-idcard-front-report',
  standalone: true,
  imports: [CommonModule, NgSelectModule, RouterModule, DataTablesModule, FormsModule, LoaderComponent, NgbDatepickerModule],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './idcard-front-report.component.html',
  styleUrl: './idcard-front-report.component.scss'
})
export class IDCardFrontReportComponent {
  isDisabled: boolean = false;
  user = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  Filter = {
    SelectType: 1,
    EmpType: null as any,
    BranchID: null,
    ClientID: null,
    SiteID: null,
    EmpCode : null
  }
  Detail = {
    EmpMatserId: null as any,
    ReportDate: null as any,
    ReportDateObj: null as any,
    BranchId: null,
    EmpCode: null
  }
  BranchMaster: any[] = [];
  ClientMaster: any[] = [];
  SiteMaster: any[] = [];
  EmpMaster: any[] = [];

  TypeData: any = null;
  dtoptions: DataTables.Settings = {};
  constructor(
    protected common: CommonService,
    private tooltip: TooltipService,
    private session: SessionService,
    private router: Router,
    private toast: ToastService,
    private comboload: ComboService,
    private idcardfrontback: IDCardFrontBackService,
    private modalService: NgbModal,
    private dateFormate: CustomDateParserFormatter,
    private utility: UtilityService,
    private route: ActivatedRoute
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.TypeData = this.route.snapshot.data['type']; // Will either be 'IDCard' or 'Biodata'
    this.Filter.EmpType = this.router.url.split('/')[3];
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('Branch');
    this.SelectDate('RegistrationDate', null, null);
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.Detail.ReportDateObj = this.dateFormate.parse(response.Table[0].RegistrationDate)
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  Validate(form: any) {
    this.EmpMaster = [];
    if (form.valid) {
      // if (this.TypeData === 'IDCard') {
      //   this.getData();
      // } else if (this.TypeData === 'Biodata') {

      // }
      this.getData();
    }
    else {
      form.submitted = true;
    }
  }
  getData() {
    this.isDisabled = true;
    this.EmpMaster = Object.values([]);
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
    this.idcardfrontback.IdCardEmp(this.Filter).subscribe({
      next: (response) => {
        if (response.Table) {
          this.EmpMaster = Object.values(response.Table);
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.isDisabled = true;
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client') ? this.Filter.BranchID : 0,
      'ClientId': (Combotype == 'Site') ? this.Filter.ClientID : 0,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          this.BranchMaster = response.ComboLoad;
        } else if (Combotype == 'Client') {
          this.ClientMaster = response.ComboLoad;

        } else if (Combotype == 'Site') {
          this.SiteMaster = response.ComboLoad;
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false
      },
    });
  }

  InsertUpdate() {
    const selectedItems = this.EmpMaster.filter(item => item.selected);
    if (selectedItems.length === 0) {
      this.toast.show({ message: 'Please select at least 1 Employee!', type: toastTypeEnum.warning });
      return;
    }
    const empIDs = selectedItems.map(item => item['EmpMasterID']);
    this.Detail.EmpMatserId = empIDs.join(', ');
    this.Detail.BranchId = this.Filter.BranchID;
    this.Detail.ReportDate = this.dateFormate.format(this.Detail.ReportDateObj)
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      //centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you sure want to print?'
    modalRef.result.then((result: any) => {
      if (result) {
        this.isDisabled = true;
        if (this.common.PageRight.IsPrint) {
          if (this.TypeData === 'IDCard') {
            this.idcardfrontback.IDCardFrontBack(this.Detail).subscribe({
              next: (response) => {
                window.open(response.FileName, '_blank');
                this.isDisabled = false;
              },
              complete: () => { },
              error: (error) => {
                this.isDisabled = false;
              },
            });
          } else if (this.TypeData === 'Biodata') {
            this.idcardfrontback.EmployeeDetails({ SelectType: 'EmployeeDetails', ID: 0, IDs: this.Detail.EmpMatserId, BranchID: this.Filter.BranchID }).subscribe({
              next: (response) => {
                window.open(response.FullFileName, '_blank');
                this.isDisabled = false;
              },
              complete: () => { },
              error: (error) => {
                this.isDisabled = false;
              },
            });
          }
        }
        else {
          this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
        }

      }
    }).catch(() => {
      this.isDisabled = false
    });

  }

  selectAll(event: any) {
    const isChecked = event.target.checked;
    this.EmpMaster.forEach((shift) => {
      shift.selected = isChecked;
    });
  }
  selectRow(event: any, shift: any) {
    shift.selected = event.target.checked;
  }
  onSelectChange(type: string) {
    if (type === 'Branch') {
      this.EmpMaster = [];
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
      this.Filter.ClientID = null
      this.ClientMaster = [];
      this.Filter.SiteID = null
      this.SiteMaster = []
    } else if (type === 'Client') {
      this.EmpMaster = [];
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
      this.Filter.SiteID = null
      this.SiteMaster = []
    } else if (type === 'Site') {
      this.EmpMaster = [];
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    }
  }
}
